@if (entry) {
    <div class="row">
        <div class="col">
            <div class="no-spacing text-bold" [innerHTML]="hearingDescription(entry.extras['hearing_type'], entry.extras['hearing_details'])"></div>
            <ng-container *ngTemplateOutlet="documentsTable; context: {$implicit: entry.extras['documents'], showType:false}"></ng-container>
        </div>
    </div>
    @if (entry.extras['agenda']?.length > 0) {
    <div class="row">
        <div class="col">
            <h5 class="column-header">AGENDA</h5>
            <table class="table table-striped table-borderless">
                <tbody>
                    @for (item of entry.extras['agenda']; track item.agenda_id) {
                    <tr>
                        <td>
                            <ng-container *ngTemplateOutlet="documentsTable; context: {$implicit: item.agenda_document, showType:false}"></ng-container>
                            <ul class="list-unstyled">
                                @if (item.agenda_status?.length > 1) {
                                <li><strong>Status: </strong>{{item.agenda_status}}</li>
                                }
                                @if (item.agenda_details?.length > 1) {
                                <li><strong>Details: </strong><span [innerHTML]="item.agenda_details | safeHtml"></span></li>
                                }
                                @if (item.objection_response_date?.length > 1) {
                                <li><strong>Objections by: </strong>{{item.objection_response_date}}</li>
                                }
                                @if (item.reply_deadline?.length > 1) {
                                <li><strong>Reply by: </strong>{{item.reply_deadline}}</li>
                                }
                            </ul>
                            <ng-container *ngTemplateOutlet="documentsWithFoldout; context: {$implicit: item.documents, id: 'agenda' + item.agenda_id}"></ng-container>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    }

    <ng-template #documentsWithFoldout let-dockets let-id="id">
    @if (dockets.length > 0) {

    <h5 (click)="isExpanded[id] = ! isExpanded[id]">
        <i-bs [name]="iconNames.ChevronDown" [@openClose]="isExpanded[id] ? 'open' : 'closed'" class="d-inline-block"></i-bs>&nbsp;Related Documents
    </h5>
    @if (isExpanded[id]) {
        <ng-container *ngTemplateOutlet="documentsTable; context: {$implicit: dockets, showType: true}"></ng-container>
    }
    }


    </ng-template>

    <ng-template #documentsTable let-dockets let-showType="showType">
    <table class="table table-borderless" style="--bs-table-bg: transparent">
        <tbody>
            @for (aDocument of dockets; track aDocument.docket_number) {
            <tr>
                <td>
                    <span [innerHTML]="aDocument.Name | safeHtml"></span>
                </td>
                @if (showType) {
                    <td>
                        {{ aDocument.types }}
                    </td>
                }
                <td>
                    <app-document-links [item]="aDocument" (purchased)="documentPurchased()"></app-document-links>
                </td>
            </tr>
            }
        </tbody>
    </table>
    </ng-template>

    <adobe-pdf-viewer></adobe-pdf-viewer>
}
